const DEBUG = true;

export const ENDPOINT_PATHS = {
    // @TEMPLATE - Define the API endpoint paths here.
    root: 'api',
    exampleGet: 'exampleget',
    examplePost: 'examplepost',
    getConfiguration: 'configuration',
}

export const ENDPOINTS = {
    // @TEMPLATE - Define the API endpoints here.
    exampleGet: 'exampleGet',
    examplePost: 'examplePost',
    getConfiguration: 'getConfiguration',
}

export const ENDPOINT_METHODS = {
    // @TEMPLATE - Define the API endpoints here.
    exampleGet: 'GET',
    examplePost: 'POST',
    getConfiguration: 'GET',
}

export const QUERYKEYS = ENDPOINTS;

// Convenience function to create the endpoint URLs for the chat API.
export const createEndpointUrl = function ({ endpoint, parameters, body }) {
    if (DEBUG) console.log(`createEndpointUrl: ${endpoint}`);
    if (DEBUG && parameters) console.log(parameters);
    if (DEBUG && body) console.log(body);
    switch (endpoint) {
        case ENDPOINTS.exampleGet:
            var root = ENDPOINT_PATHS.root;

            return `${ENDPOINT_PATHS.exampleGet}`;
        case ENDPOINTS.examplePost:
            if (!body) {
                throw new Error(`Empty body given for ${endpoint}`);
            }

            var root = ENDPOINT_PATHS.root;

            return `${ENDPOINT_PATHS.examplePost}`;
        case ENDPOINTS.getConfiguration:
            var root = ENDPOINT_PATHS.root;

            return `${ENDPOINT_PATHS.getConfiguration}`;
        default:
            throw new Error(`Unknown endpoint: ${endpoint}`);
    }
}